// Invocato quando il server risponde quota_esaurita: apre la finestra globale QuotaGate.
export function notifyQuotaExhausted() {
  window.dispatchEvent(new CustomEvent("arcana-quota-exhausted"));
}
